import { Stack, type SxProps, type Theme, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  headerText: ReactNode;
  subheaderText?: ReactNode;
  sx?: SxProps<Theme>;
}

export function FormHeader({ headerText, subheaderText, sx }: Props) {
  return (
    <Stack
      sx={{
        gap: 2,
        mb: 4,
        ...sx,
      }}
    >
      <Typography variant="h1">{headerText}</Typography>
      {subheaderText && (
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {subheaderText}
        </Typography>
      )}
    </Stack>
  );
}
